import React from "react";
import PropTypes from "prop-types";

import { Translate } from "utils";

import Area from "./Area";
import Capacity from "./Capacity";

import styles from "./SpaceSizeEdit.css";

const { t } = new Translate();

const CapacityPrimary = ({ area, capacity, onChangeArea, onChangeCapacity }) => (
  <div className={styles.root}>
    <Capacity capacity={capacity} onChange={onChangeCapacity} />
    <div className={styles.small}>{t("in")}</div>
    <Area area={area} onChange={onChangeArea} />
  </div>
);

CapacityPrimary.propTypes = {
  area: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    unit: PropTypes.string,
  }),
  capacity: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    unit: PropTypes.string,
  }),
  onChangeArea: PropTypes.func.isRequired,
  onChangeCapacity: PropTypes.func.isRequired,
};

export default CapacityPrimary;
